import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import ServiceScheduleException from 'interfaces/serviceScheduleException';

const useServiceScheduleException = ({
  startDate,
  endDate,
  serviceId,
}: {
  startDate: string;
  endDate: string;
  serviceId: string;
}) => {
  const query = new URLSearchParams({
    startDate,
    endDate,
  }).toString();

  const url = `/services/${serviceId}/exceptions?${query}`;
  const clinicId = loadSelectedClinicId();
  const { data, error, mutate } = useSWR(
    [url, clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<ServiceScheduleException[]>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useServiceScheduleException;
